function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { memo, useState } from "react";
import OnColorContext from "../../../../../contexts/OnColorContext";
import ArrowLinkAtm from "../../../../atoms/ArrowLinkAtm";
import ButtonAtm from "../../../../atoms/ButtonAtm";
import TextAtm from "../../../../atoms/TextAtm";
import FlexContainerOrg from "../../../../organisms/FlexContainerOrg";
import PushOrg from "../../../../organisms/PushOrg";
import { Label } from "../../common";
import { headerBackgroundOnBiggerScreen, headerBackground } from "../Header.settings";
import Dropdown from "./Dropdown";
import { Cell, Title, StyledTooltip, LinkedTitle, HeaderWrapper } from "./HeaderContent.styled";
/* eslint-disable react/no-array-index-key */
function HeaderContent(_ref) {
  var label = _ref.label,
    columns = _ref.columns,
    numberOfColumns = _ref.numberOfColumns,
    isBiggerScreen = _ref.isBiggerScreen;
  var hasColumns = columns && columns.length > 0;
  var someHeaderHasLink = hasColumns && !!columns.filter(function (_ref2) {
    var link = _ref2.link;
    return !!link;
  }).length;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    visibleDropdownIndex = _useState2[0],
    setVisibleDropdownIndex = _useState2[1];
  var headerTitleTypography = isBiggerScreen ? "big3" : "small4";
  var headerTitleHeadingTypography = isBiggerScreen ? "small3" : "nano2";
  var headerOnColor = isBiggerScreen ? headerBackgroundOnBiggerScreen : headerBackground;
  var handleDropdownToggleClick = function handleDropdownToggleClick(index) {
    return function (event) {
      event.preventDefault();
      setVisibleDropdownIndex(index);
    };
  };
  return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: headerOnColor
  }, /*#__PURE__*/React.createElement(HeaderWrapper, {
    $numberOfColumns: numberOfColumns
  }, isBiggerScreen || !hasColumns ? /*#__PURE__*/React.createElement(Cell, null, /*#__PURE__*/React.createElement(Label, null, label)) : null, hasColumns ? columns.map(function (_ref3, index) {
    var heading = _ref3.heading,
      title = _ref3.title,
      titleTo = _ref3.titleTo,
      titleHref = _ref3.titleHref,
      button = _ref3.button,
      link = _ref3.link,
      dropdown = _ref3.dropdown,
      isActive = _ref3.isActive,
      tooltip = _ref3.tooltip;
    var linkTitle = heading ? "".concat(heading, " ").concat(title) : title;
    var titleJsx;
    if (titleHref) {
      titleJsx = /*#__PURE__*/React.createElement(LinkedTitle, {
        to: titleTo,
        href: titleHref,
        title: title,
        $typography: headerTitleTypography,
        $onColor: headerOnColor
      }, title);
    } else {
      titleJsx = /*#__PURE__*/React.createElement(TextAtm, {
        typography: headerTitleTypography
      }, title);
    }
    return /*#__PURE__*/React.createElement(Cell, {
      $isActive: !!isActive,
      $hasLink: !!link,
      $otherHeaderHasLink: !link && someHeaderHasLink,
      key: "Cell-".concat(index)
    }, /*#__PURE__*/React.createElement(Title, {
      $hasSeparator: !button && index + 1 < numberOfColumns
    }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
      alignItems: "center",
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement("div", null, heading ? /*#__PURE__*/React.createElement(TextAtm, {
      typography: headerTitleHeadingTypography
    }, heading) : null, titleJsx), tooltip ? /*#__PURE__*/React.createElement(StyledTooltip, null, tooltip) : null)), button ? /*#__PURE__*/React.createElement(PushOrg, {
      topSpace: 1,
      bottomSpace: 0.5
    }, /*#__PURE__*/React.createElement(ButtonAtm, {
      to: button.to,
      href: button.href,
      title: button.title,
      onClick: button.onClick,
      rel: button.rel,
      size: "small",
      isWider: true,
      "data-test-id": "table-add-button"
    }, button.text)) : null, link ? /*#__PURE__*/React.createElement(ArrowLinkAtm, {
      to: link.to,
      href: link.href,
      title: linkTitle,
      typography: "tiny2",
      rel: link.rel,
      openInNewTab: link.openInNewTab,
      onClick: link.onClick,
      "data-test-id": "table-link"
    }, link.text) : null, dropdown ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArrowLinkAtm, {
      href: "#",
      title: dropdown.label,
      onClick: handleDropdownToggleClick(index),
      emphasis: "high",
      arrowDirection: "down",
      "data-test-id": "table-dropdown-link"
    }, dropdown.label), visibleDropdownIndex === index && /*#__PURE__*/React.createElement(Dropdown, {
      items: dropdown.items,
      setVisibleDropdownIndex: setVisibleDropdownIndex
    })) : null);
  }) : null));
}
export default /*#__PURE__*/memo(HeaderContent);